import { Note } from '../../types';

export interface NotesListViewData {
  isBackButtonEnabled: boolean;
  notes: Note[];
}

export interface CreateNoteRequest {
  text: string;
}

export interface UpdateNoteRequest {
  _id: string;
  text: string;
}

export interface DeleteNoteRequest {
  _id: string;
}

export enum NoteEvents {
  GO_BACK = 'goBack',
  CREATE_NOTE_CARD = 'createNoteCard',
  CREATE_NOTE = 'createNote',
  EDIT_NOTE_CARD = 'editNoteCard',
  EDIT_NOTE = 'editNote',
  DELETE_NOTE_CARD = 'deleteNoteCard',
  DELETE_NOTE = 'deleteNote',
  CLOSE_EDIT_WINDOW = 'closeEditWindow',
}
